import { adminRequests } from 'api/request';
import urls from 'configs/urls';

export const getPendingClosedCircles = ({ data }) =>
  adminRequests.get(null, false, urls.circlesUrls.getPendingClosedCircles, data);

export const changeClosedCircleStatus = ({ data, circleKey }) =>
  adminRequests.patch(null, false, `${urls.circlesUrls.changeClosedCircleStatus(circleKey)}`, data);
